;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { ReactNode } from 'react';

export type Type = 'red' | 'gray' | 'outline' | 'outlineWhite' | 'outlineRed';

type Props = {
  children: ReactNode;
  type: Type;
  className?: string;
  arrow?: boolean;
  onClick?: () => void;
};

export default function Button({ children, type, className, arrow = false, onClick = undefined }: Props) {
  let classes;
  let style = {};
  switch (type) {
    case 'red':
      classes = `cta red rounded-pill fw-normal ${arrow ? 'arrow' : 'noArrow px-4'}`;
      break;
    case 'gray':
      classes = `cta noArrow gray rounded-pill px-3 ${arrow ? 'arrow' : 'noArrow'}`;
      break;
    case 'outline':
      classes = `cta noArrow outline rounded-pill ${arrow ? 'arrow' : 'noArrow'}`;
      break;
    case 'outlineWhite':
      classes = `cta noArrow outline text-white border-white rounded-pill ${arrow ? 'arrow' : 'noArrow'}`;
      break;
    case 'outlineRed':
      classes = `cta noArrow outline rounded-pill ${arrow ? 'arrow' : 'noArrow'}`;
      style = { color: '#E2001A', borderColor: '#E2001A' };
      break;
  }
  return (
    <button onClick={onClick} className={`${classes} ${className}`} style={style}>
      {children}
    </button>
  );
}
